export enum NewPeriodSelectorIntervalType {
  Calendar = 1,
  CropCycle = 2,
}
